import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { loadIpmaCisBarCreator } from 'store/actionsCreators';
import { useTranslation } from 'react-i18next';
import { useSubRoutes, useExactRedirect, usePermissionTabs } from 'hooks';
import { globalPropTypes } from 'helpers';
import { Alerts } from 'components';
import CisTabs from 'components/CisTabs/CisTabs';
import CisHeader from 'components/CisHeader/CisHeader';

const breadcrumbs = [
  {
    title: 'navigation.breadcrumbs.ipma.cis',
    url: '/ipma/cis',
  },
];

const initialTabs = [
  {
    title: 'navigation.tabs.user.cis.certificationBodies',
    path: '/ipma/cis/certification-bodies',
    key: 'certificationBodies',
  },
  {
    title: 'navigation.tabs.user.cis.certificateHolders',
    path: '/ipma/cis/certificate-holders',
    key: 'certificateHolders',
  },
  {
    title: 'navigation.tabs.user.cis.certificates',
    path: '/ipma/cis/certificates',
    key: 'certificates',
  },
  {
    title: 'navigation.tabs.user.cis.invoices',
    path: '/ipma/cis/invoices',
    key: 'invoices',
  },
  {
    title: 'navigation.tabs.user.cis.organizations',
    path: '/ipma/cis/organizations',
    key: 'organizations',
  },
  {
    title: 'navigation.tabs.user.cis.deltaCertificates',
    path: '/ipma/cis/delta-certificates',
    key: 'deltaCertificates',
  },
  {
    title: 'navigation.tabs.user.cis.agreements',
    path: '/ipma/cis/agreements',
    key: 'agreements',
  },
  {
    title: 'navigation.tabs.user.cis.levelDomains',
    path: '/ipma/cis/level-domains',
    key: 'levelDomains',
  },
  {
    title: 'navigation.tabs.user.cis.signatures',
    path: '/ipma/cis/signatures',
    key: 'signatures',
  },
  {
    title: 'navigation.tabs.user.cis.unknownImports',
    path: '/ipma/cis/unknown-imports',
    key: 'unknownImports',
  },
  {
    title: 'navigation.tabs.user.cis.changeRequests',
    path: '/ipma/cis/change-requests',
    key: 'changeRequests',
  }
];

const Cis = ({ routes, loadBar, bar, userPermissions }) => {
  const { t } = useTranslation();

  const [renderSubRoutes] = useSubRoutes(routes);
  const [tabs, firstTabPath] = usePermissionTabs(initialTabs, routes, userPermissions, bar);
  const [renderExactRedirect] = useExactRedirect('/ipma/cis', firstTabPath);

  return (
    <>
      <CisHeader
        breadcrumbs={breadcrumbs}
        title={t('page.ipma.cis.title')}
        renderActions={() => <div id="ipma-cis-buttons-portal"></div>}
      />
      <CisTabs disableCounter={true} items={tabs} />
      <Alerts type="cis" />
      {renderExactRedirect()}
      {renderSubRoutes()}
    </>
  );
};

Cis.propTypes = {
  routes: PropTypes.arrayOf(globalPropTypes.RoutePropTypes),
  userPermissions: globalPropTypes.UserPermissions.isRequired,
  bar: PropTypes.shape({
    certificationBodies: PropTypes.number,
    cetificateHolders: PropTypes.number,
    certificates: PropTypes.number,
    levelDomains: PropTypes.number,
    invoices: PropTypes.number,
    agreements: PropTypes.number,
    organizations: PropTypes.number,
    reports: PropTypes.number,
  }).isRequired,
};

Cis.defaultProps = {
  routes: [],
};

const mapStateToProps = ({ ipma, user }) => ({
  bar: ipma.cis.bar,
  userPermissions: user.userPermissions,
});

const mapDispatchToProps = (dispatch) => ({
  loadBar: () => dispatch(loadIpmaCisBarCreator()),
});

export default connect(mapStateToProps, mapDispatchToProps)(Cis);
